// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Fgzh","title":"Header_title__1Gb8y","side":"Header_side__kbjuK"};